export default __webpack_public_path__ + "static/media/02.67808028.jpg";